
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

import NavDrawer from "../../components/NavDrawer/NavDrawer";
import FundsButtonRow from "../../components/FundsButtonRow";
import React, { useEffect, useState } from "react";

import Navbar from "../../components/Navbar/Navbar";
import axios from "../../api/axiosInstance";
import { CashFundCard } from "../../components/Cashfund/CashFundCard";

const Home_Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const [cashFunds, setCashFunds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");


  const handleLogout = () => {
    logout();
    navigate("/");
  };

    const fetchCashFunds = async () => {
    try {
      setLoading(true);
      setErr("");
      const res = await axios.get("/v1/cashfund/my");
      setCashFunds(res.data.data || []);
    } catch (e) {
      setErr(e.response?.data?.message || "Failed to load funds.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCashFunds();
  }, []);



  return (
    <div style={{ minHeight: "100vh", position: "relative", background: "#FFFDFB" }}>
      <Navbar />
      <div style={{ display: "flex", flexDirection: "row" }}>
        {/* Drawer */}
        <div style={{ flexShrink: 0, width: 120, background: "#fff" }}>
          <NavDrawer highlight="HOME" />
        </div>
        {/* Main Content */}

        <div style={{ flexGrow: 1, padding: "36px 36px", overflowY: "auto", height: "100vh" }}>
  <div style={{ textAlign: "left", marginBottom: "20px", fontFamily: "'Nunito', sans-serif" }}>
    <h2 style={{ margin: 0 }}>Welcome Back</h2>
    <h2 style={{ margin: 0 }}>{user?.firstName},</h2>
  </div>
  <FundsButtonRow />


        <div style={{
          flex: 1,
          padding: "48px 36px 36px 36px",
          maxWidth: 1200,
          margin: "0 auto",
        }}>
          <div style={{
            paddingTop: 32,
            textAlign: "center"
          }}>
            
          
          </div>
          {/* Cash Funds List */}
          <div style={{ maxWidth: "1100px" }}>
           
            {loading && <div>Loading...</div>}
            {err && <div style={{ color: "red" }}>{err}</div>}
            {!loading && !err && cashFunds.length === 0 && (
              <div>No cash funds found.</div>
            )}
            <div style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "28px",
              justifyContent: "flex-start",
            }}>
              {cashFunds.map(fund => (
                <CashFundCard key={fund.cash_fund_id} fund={fund} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );



};

export default Home_Dashboard;
